export function manufacturedHomeContracttoBuyandSellLotLeaseOnly2026() {
return [   // Release 2025-12-31 07:05:31
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 279.96,
   left: 467.52,
   width: 105.12,
   height: 12.142
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 369.68,
   left: 105.72,
   width: 469.92,
   height: 12.142
}
,
{
   page: 0,
   name: "Radiobutton Title Joint Tenants", 
   isText: false,
   type: "checkbox",
   top: 399,
   left: 50.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Radiobutton Title Tenants In Common", 
   isText: false,
   type: "checkbox",
   top: 399,
   left: 137.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Radiobutton Title Other", 
   isText: false,
   type: "checkbox",
   top: 399,
   left: 254.52,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Title Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 396.2,
   left: 302.88,
   width: 278.64,
   height: 12.142
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 428.0,
   left: 104.04,
   width: 469.92,
   height: 12.142
}
,
{
   page: 0,
   name: "Manufacturer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 505.72,
   left: 181.08,
   width: 396.12,
   height: 13.527
}
,
{
   page: 0,
   name: "Model", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 523.72,
   left: 181.08,
   width: 396.12,
   height: 13.527
}
,
{
   page: 0,
   name: "Serial No", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 541.72,
   left: 181.08,
   width: 396.12,
   height: 13.527
}
,
{
   page: 0,
   name: "Size", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 559.72,
   left: 181.08,
   width: 396.12,
   height: 13.527
}
,
{
   page: 0,
   name: "Year of Manufacture", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 577.72,
   left: 181.08,
   width: 396.12,
   height: 13.527
}
,
{
   page: 0,
   name: "Certificate No", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 595.72,
   left: 181.08,
   width: 396.12,
   height: 13.527
}
,
{
   page: 0,
   name: "Manufacturer Tag No", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 613.72,
   left: 181.08,
   width: 396.12,
   height: 13.527
}
,
{
   page: 0,
   name: "VIN No", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 631.72,
   left: 181.08,
   width: 396.12,
   height: 13.527
}
,
{
   page: 0,
   name: "Address County", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 649.8,
   left: 389.04,
   width: 156.60,
   height: 13.527
}
,
{
   page: 0,
   name: "Space No", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 689.8,
   left: 181.08,
   width: 398.76,
   height: 13.5273
}
,
{
   page: 0,
   name: "Mobile Home Park", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 707.8,
   left: 181.08,
   width: 398.76,
   height: 13.5273
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 726.2655,
   left: 116.64,
   width: 468.48,
   height: 13.5272
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Solar Panels", 
   isText: false,
   type: "checkbox",
   top: 120.28,
   left: 74.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Water Softeners", 
   isText: false,
   type: "checkbox",
   top: 120.36,
   left: 150.316,
   width: 10.080,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Security Systems", 
   isText: false,
   type: "checkbox",
   top: 120.295,
   left: 247.516,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Satellite Systems", 
   isText: false,
   type: "checkbox",
   top: 120.884,
   left: 347.334,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Inclusions Encumbered", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 262.512,
   left: 64.9307,
   width: 523.1603,
   height: 82.873
}
,
{
   page: 1,
   name: "Radiobutton AssumeDebtOnEncumberedInclusions Will", 
   isText: false,
   type: "checkbox",
   top: 346.964,
   left: 90.9055,
   width: 10.0795,
   height: 10.080
}
,
{
   page: 1,
   name: "Radiobutton AssumeDebtOnEncumberedInclusions Will Not", 
   isText: false,
   type: "checkbox",
   top: 346.964,
   left: 136.785,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Inclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 398.227,
   left: 58.2549,
   width: 524.4021,
   height: 82.219
}
,
{
   page: 1,
   name: "Checkbox ChecklistItem Personal Property Agreement", 
   isText: false,
   type: "checkbox",
   top: 480.92,
   left: 58.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Leased Items", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 555.482,
   left: 58.263,
   width: 527.827,
   height: 66.267
}
,
{
   page: 1,
   name: "Radiobutton BuyerAssumeSellerDebtOnLeasedItems Will", 
   isText: false,
   type: "checkbox",
   top: 633.872,
   left: 134.695,
   width: 10.080,
   height: 10.081
}
,
{
   page: 1,
   name: "Radiobutton BuyerAssumeSellerDebtOnLeasedItems Will Not", 
   isText: false,
   type: "checkbox",
   top: 633.872,
   left: 181.575,
   width: 10.735,
   height: 10.081
}
,
{
   page: 1,
   name: "Checkbox ChecklistItem Solar Power Plan", 
   isText: false,
   type: "checkbox",
   top: 665.16,
   left: 95.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Radiobutton AssumeSolarPowerPlan Will", 
   isText: false,
   type: "checkbox",
   top: 702.472,
   left: 309.443,
   width: 10.080,
   height: 10.735
}
,
{
   page: 1,
   name: "Radiobutton AssumeSolarPowerPlan Will Not", 
   isText: false,
   type: "checkbox",
   top: 702.472,
   left: 354.083,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Parking", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 49.68,
   left: 68.16,
   width: 480.00,
   height: 13.80
}
,
{
   page: 2,
   name: "Storage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 64.8,
   left: 253.56,
   width: 325.08,
   height: 13.8
}
,
{
   page: 2,
   name: "Radiobutton LotOwnerApprovalFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 283.08,
   left: 63.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Radiobutton LotOwnerApprovalFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 283.446,
   left: 113.378,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Radiobutton LotOwnerApprovalFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 283.446,
   left: 161.03,
   width: 10.08,
   height: 10.080
}
,
{
   page: 2,
   name: "Radiobutton LotOwnerApprovalFeePaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 282.624,
   left: 347.529,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Exclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 111.124,
   left: 58.1538,
   width: 521.1292,
   height: 82.873
}
,
{
   page: 2,
   name: "Time of Day Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 480.563,
   left: 413.128,
   width: 166.458,
   height: 20.378
}
,
{
   page: 2,
   name: "DateAlternative Earnest Money Deadline", 
   fontSize: 9,
   type: "date",
   top: 503.065,
   left: 334.363,
   width: 77.945,
   height: 17.760
}
,
{
   page: 2,
   name: "Alternative Earnest Money Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 501.883,
   left: 413.128,
   width: 166.458,
   height: 20.378
}
,
{
   page: 2,
   name: "DateSellers Property Disclosure Deadline", 
   fontSize: 9,
   type: "date",
   top: 714.6205,
   left: 334.363,
   width: 77.945,
   height: 17.7600
}
,
{
   page: 2,
   name: "Sellers Property Disclosure Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 714.6205,
   left: 413.128,
   width: 166.458,
   height: 20.3782
}
,
{
   page: 2,
   name: "DateLeadBased Paint Disclosure Deadline", 
   fontSize: 9,
   type: "date",
   top: 737.0205,
   left: 334.363,
   width: 77.945,
   height: 17.7600
}
,
{
   page: 2,
   name: "LeadBased Paint Disclosure Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 736.0205,
   left: 413.128,
   width: 166.458,
   height: 20.3782
}
,
{
   page: 2,
   name: "DateUCC and Certificate of Title Deadline", 
   fontSize: 9,
   type: "date",
   top: 545.447,
   left: 334.47,
   width: 77.945,
   height: 17.760
}
,
{
   page: 2,
   name: "UCC and Certificate of Title Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 545.447,
   left: 413.128,
   width: 166.458,
   height: 20.378
}
,
{
   page: 2,
   name: "DateUCC and Certificate of Title Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 566.407,
   left: 334.47,
   width: 77.945,
   height: 17.760
}
,
{
   page: 2,
   name: "UCC and Certificate of Title Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 566.407,
   left: 413.128,
   width: 166.458,
   height: 20.378
}
,
{
   page: 2,
   name: "DateUCC and Certificate of Title Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 588.367,
   left: 334.47,
   width: 77.945,
   height: 17.760
}
,
{
   page: 2,
   name: "UCC and Certificate of Title Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 587.367,
   left: 413.128,
   width: 166.458,
   height: 20.378
}
,
{
   page: 2,
   name: "DateLease Delivery Deadline", 
   fontSize: 9,
   type: "date",
   top: 630.087,
   left: 334.47,
   width: 77.945,
   height: 17.760
}
,
{
   page: 2,
   name: "Lease Delivery Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 629.087,
   left: 413.128,
   width: 166.458,
   height: 20.378
}
,
{
   page: 2,
   name: "DateLot Owner Approval Deadline", 
   fontSize: 9,
   type: "date",
   top: 651.047,
   left: 334.47,
   width: 77.945,
   height: 17.760
}
,
{
   page: 2,
   name: "Lot Owner Approval Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 650.047,
   left: 413.128,
   width: 166.458,
   height: 20.378
}
,
{
   page: 2,
   name: "DateLease Review Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 673.007,
   left: 334.47,
   width: 77.945,
   height: 17.760
}
,
{
   page: 2,
   name: "Lease Review Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 672.007,
   left: 413.128,
   width: 166.458,
   height: 20.3782
}
,
{
   page: 3,
   name: "DateNew Loan Application Deadline", 
   fontSize: 9,
   type: "date",
   top: 90.353,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "New Loan Application Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 89.542,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateNew Loan Terms Deadline", 
   fontSize: 9,
   type: "date",
   top: 111.692,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "New Loan Terms Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 110.379,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateNew Loan Availability Deadline", 
   fontSize: 9,
   type: "date",
   top: 134.092,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "New Loan Availability Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 132.779,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateBuyers Credit Information Deadline", 
   fontSize: 9,
   type: "date",
   top: 154.252,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "Buyers Credit Information Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 153.939,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateDisapproval of Buyers Credit Information Deadline", 
   fontSize: 9,
   type: "date",
   top: 174.784,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "Disapproval of Buyers Credit Information Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 174.471,
   left: 413.128,
   width: 166.458,
   height: 22.996
}
,
{
   page: 3,
   name: "DateSeller or Private Financing Deadline", 
   fontSize: 9,
   type: "date",
   top: 203.573,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "Seller or Private Financing Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 202.098,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateAppraisal Deadline", 
   fontSize: 9,
   type: "date",
   top: 247.083,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "Appraisal Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 246.083,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateAppraisal Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 268.163,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "Appraisal Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 267.163,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateAppraisal Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 289.243,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "Appraisal Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 289.243,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateInspection Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 331.391,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "Inspection Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 331.391,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateInspection Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 352.471,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "Inspection Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 351.471,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateInspection Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 373.551,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "Inspection Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 372.551,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateProperty Insurance Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 394.338,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "Property Insurance Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 394.338,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateDue Diligence Documents Delivery Deadline", 
   fontSize: 9,
   type: "date",
   top: 416.418,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "Due Diligence Documents Delivery Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 415.418,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateDue Diligence Documents Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 436.498,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "Due Diligence Documents Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 436.498,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateDue Diligence Documents Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 458.218,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "Due Diligence Documents Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 458.218,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateConditional Sale Deadline", 
   fontSize: 9,
   type: "date",
   top: 479.946,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "Conditional Sale Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 478.946,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateLeadBased Paint Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 502.592,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "LeadBased Paint Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 501.279,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateClosing Date", 
   fontSize: 9,
   type: "date",
   top: 543.854,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "Closing Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 543.228,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DatePossession Date", 
   fontSize: 9,
   type: "date",
   top: 565.066,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "Possession Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 564.621,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "Possession Time", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 584.965,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "DateAcceptance Deadline Date", 
   fontSize: 9,
   type: "date",
   top: 604.884,
   left: 333.605,
   width: 78.840,
   height: 17.760
}
,
{
   page: 3,
   name: "Acceptance Deadline Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 607.045,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "Acceptance Deadline Time", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 627.508,
   left: 413.128,
   width: 166.458,
   height: 19.069
}
,
{
   page: 3,
   name: "33Row1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 648.6,
   left: 60.96,
   width: 32.76,
   height: 19.8
}
,
{
   page: 3,
   name: " 24Row1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 648.6,
   left: 95.52,
   width: 34.20,
   height: 19.8
}
,
{
   page: 3,
   name: "Deadlines Extra Row 1 Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 648.6,
   left: 131.52,
   width: 200.76,
   height: 19.8
}
,
{
   page: 3,
   name: "Deadlines Extra Row 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 648.6,
   left: 334.08,
   width: 245.64,
   height: 19.8
}
,
{
   page: 3,
   name: "33Row2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 669.72,
   left: 60.96,
   width: 32.76,
   height: 20.04
}
,
{
   page: 3,
   name: " 24Row2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 669.72,
   left: 95.52,
   width: 34.20,
   height: 20.04
}
,
{
   page: 3,
   name: "Deadlines Extra Row 2 Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 669.72,
   left: 131.52,
   width: 200.76,
   height: 20.04
}
,
{
   page: 3,
   name: "Deadlines Extra Row 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 669.72,
   left: 334.08,
   width: 245.64,
   height: 20.04
}
,
{
   page: 4,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will", 
   isText: false,
   type: "checkbox",
   top: 190.57,
   left: 59.989,
   width: 10.080,
   height: 10.08
}
,
{
   page: 4,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will Not", 
   isText: false,
   type: "checkbox",
   top: 190.57,
   left: 106.869,
   width: 10.080,
   height: 10.08
}
,
{
   page: 4,
   name: "Amount Purchase Price", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 279.383,
   left: 285.709,
   width: 69.010,
   height: 14.158
}
,
{
   page: 4,
   name: "Amount Earnest Money", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 294.941,
   left: 368.95,
   width: 70.319,
   height: 13.504
}
,
{
   page: 4,
   name: "Amount New Loan", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 311.021,
   left: 368.95,
   width: 70.319,
   height: 13.504
}
,
{
   page: 4,
   name: "Amount Private Financing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 327.181,
   left: 368.95,
   width: 70.319,
   height: 13.504
}
,
{
   page: 4,
   name: "Amount Seller Financing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 343.261,
   left: 368.95,
   width: 70.319,
   height: 13.504
}
,
{
   page: 4,
   name: "Item 7 Reference", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 359.105,
   left: 112.342,
   width: 52.200,
   height: 15.467
}
,
{
   page: 4,
   name: "Item 7 Description", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 360.105,
   left: 167.342,
   width: 101.640,
   height: 14.158
}
,
{
   page: 4,
   name: "Amount Item 7 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 359.687,
   left: 285.709,
   width: 69.010,
   height: 14.158
}
,
{
   page: 4,
   name: "Amount Item 7 Credit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 360.341,
   left: 368.95,
   width: 70.319,
   height: 13.504
}
,
{
   page: 4,
   name: "Item 8 Reference", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 376.185,
   left: 113.028,
   width: 52.200,
   height: 15.467
}
,
{
   page: 4,
   name: "Item 8 Description", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 376.185,
   left: 167.342,
   width: 101.640,
   height: 14.158
}
,
{
   page: 4,
   name: "Amount Item 8 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 376.767,
   left: 285.709,
   width: 69.010,
   height: 14.158
}
,
{
   page: 4,
   name: "Amount Item 8 Credit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 376.421,
   left: 368.95,
   width: 70.319,
   height: 13.504
}
,
{
   page: 4,
   name: "Amount Cash at Closing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 392.741,
   left: 368.95,
   width: 70.319,
   height: 13.504
}
,
{
   page: 4,
   name: "CALCULATE Amount Purchase Price PLUS Amount Item 7 Debit PLUS Amount Item 8 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 409.007,
   left: 285.709,
   width: 69.010,
   height: 14.158
}
,
{
   page: 4,
   name: "CALCULATE Amount Earnest Money PLUS Amount New Loan PLUS Amount Private Financing PLUS Amount Seller Financing PLUS Amount Item 7 Credit PLUS Amount Item 8 Credit PLUS Amount Cash at Closing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 408.661,
   left: 368.95,
   width: 70.319,
   height: 13.504
}
,
{
   page: 4,
   name: "Amount Seller Concession", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 429.185,
   left: 339.589,
   width: 109.920,
   height: 13.080
}
,
{
   page: 4,
   name: "Earnest Money Form", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 482.966,
   left: 387.251,
   width: 185.945,
   height: 13.080
}
,
{
   page: 4,
   name: "Earnest Money Holder", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 497.541,
   left: 173.749,
   width: 301.560,
   height: 11.771
}
,
{
   page: 5,
   name: "Radiobutton AvailableFunds Does have funds", 
   isText: false,
   type: "checkbox",
   top: 192.927,
   left: 415.102,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Radiobutton AvailableFunds Does not have funds", 
   isText: false,
   type: "checkbox",
   top: 192.6,
   left: 457.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "the following type of loan", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 288.72,
   left: 172.32,
   width: 379.68,
   height: 11.64
}
,
{
   page: 5,
   name: "Radiobutton SellerFinancingDeliversFinancingDocuments Buyer", 
   isText: false,
   type: "checkbox",
   top: 375.327,
   left: 486.862,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Radiobutton SellerFinancingDeliversFinancingDocuments Seller", 
   isText: false,
   type: "checkbox",
   top: 375.327,
   left: 533.465,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Seller Financing Deliver Financing Documents Number Days before Seller or Private Financing Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 387.796,
   left: 403.56,
   width: 50.04,
   height: 10.004
}
,
{
   page: 6,
   name: "Radiobutton WhoPaysAppraisal Buyer", 
   isText: false,
   type: "checkbox",
   top: 547.105,
   left: 56.2655,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 6,
   name: "Radiobutton WhoPaysAppraisal Seller", 
   isText: false,
   type: "checkbox",
   top: 548.105,
   left: 104.825,
   width: 10.080,
   height: 10.080
}
,
{
   page: 8,
   name: "Checkbox ChecklistItem Occupancy Agreements", 
   isText: false,
   type: "checkbox",
   top: 136.44,
   left: 104.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "Checkbox ChecklistItem Leased Items Documents", 
   isText: false,
   type: "checkbox",
   top: 219.48,
   left: 104.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "Checkbox ChecklistItem Encumbered Inclusions Documents", 
   isText: false,
   type: "checkbox",
   top: 260.28,
   left: 104.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "Checkbox ChecklistItem Copy of any Solar Power Plan not included in Leased Items", 
   isText: false,
   type: "checkbox",
   top: 302.28,
   left: 104.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "Checkbox ChecklistItem Other Documents", 
   isText: false,
   type: "checkbox",
   top: 318.12,
   left: 104.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "Occupancy Agreements", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 172.479,
   left: 59.0084,
   width: 520.5156,
   height: 45.982
}
,
{
   page: 8,
   name: "Documents Other", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 328.376,
   left: 59.3017,
   width: 522.2673,
   height: 71.023
}
,
{
   page: 8,
   name: "Conditional On Sale Of Property", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 646.793,
   left: 58.5481,
   width: 515.2199,
   height: 13.004
}
,
{
   page: 9,
   name: "Closing Designated By", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 729.6,
   left: 122.28,
   width: 300.00,
   height: 12.84
}
,
{
   page: 9,
   name: "Closing Company", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 743.52,
   left: 53.76,
   width: 399.96,
   height: 12.84
}
,
{
   page: 10,
   name: "Radiobutton ClosingServicesFee Buyer", 
   isText: false,
   type: "checkbox",
   top: 407.88,
   left: 54.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton ClosingServicesFee Seller", 
   isText: false,
   type: "checkbox",
   top: 407.88,
   left: 108.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton ClosingServicesFee Split", 
   isText: false,
   type: "checkbox",
   top: 407.88,
   left: 161.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton ClosingServicesFee Other", 
   isText: false,
   type: "checkbox",
   top: 407.88,
   left: 368.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "ClosingServicesFee Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 406.2,
   left: 411.36,
   width: 162.72,
   height: 11.64
}
,
{
   page: 10,
   name: "Radiobutton LotLeaseStatusLetter NA", 
   isText: false,
   type: "checkbox",
   top: 493.56,
   left: 69.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton LotLeaseStatusLetter Buyer", 
   isText: false,
   type: "checkbox",
   top: 493.56,
   left: 113.88,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton LotLeaseStatusLetter Seller", 
   isText: false,
   type: "checkbox",
   top: 493.56,
   left: 170.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton LotLeaseStatusLetter Split", 
   isText: false,
   type: "checkbox",
   top: 493.56,
   left: 226.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton LotLeaseAncillaryFees NA", 
   isText: false,
   type: "checkbox",
   top: 507.48,
   left: 182.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton LotLeaseAncillaryFees Buyer", 
   isText: false,
   type: "checkbox",
   top: 507.48,
   left: 226.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton LotLeaseAncillaryFees Seller", 
   isText: false,
   type: "checkbox",
   top: 507.48,
   left: 282.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton LotLeaseAncillaryFees Split", 
   isText: false,
   type: "checkbox",
   top: 507.48,
   left: 337.8,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton UtilityTransferFees NA", 
   isText: false,
   type: "checkbox",
   top: 537.96,
   left: 54.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton UtilityTransferFees Buyer", 
   isText: false,
   type: "checkbox",
   top: 537.96,
   left: 98.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton UtilityTransferFees Seller", 
   isText: false,
   type: "checkbox",
   top: 537.96,
   left: 153.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton UtilityTransferFees Split", 
   isText: false,
   type: "checkbox",
   top: 537.96,
   left: 209.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton SalesAndUseTax NA", 
   isText: false,
   type: "checkbox",
   top: 568.44,
   left: 54.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton SalesAndUseTax Buyer", 
   isText: false,
   type: "checkbox",
   top: 568.44,
   left: 97.32,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton SalesAndUseTax Seller", 
   isText: false,
   type: "checkbox",
   top: 568.44,
   left: 152.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton SalesAndUseTax Split", 
   isText: false,
   type: "checkbox",
   top: 568.44,
   left: 207,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton Taxes Taxes for the Calendar Year Immediately Preceding Closing", 
   isText: false,
   type: "checkbox",
   top: 628.68,
   left: 59.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton Taxes Most Recent Mill Levy and Most Recent Assessed or Actual Valuation per the county assessor", 
   isText: false,
   type: "checkbox",
   top: 645.48,
   left: 59.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton Taxes Other", 
   isText: false,
   type: "checkbox",
   top: 663.057,
   left: 59.5639,
   width: 10.0800,
   height: 10.081
}
,
{
   page: 10,
   name: "Taxes Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 660.6,
   left: 110.52,
   width: 460.08,
   height: 11.64
}
,
{
   page: 10,
   name: "Radiobutton Rents Actually Received", 
   isText: false,
   type: "checkbox",
   top: 679.08,
   left: 184.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton Rents Accrued", 
   isText: false,
   type: "checkbox",
   top: 679.08,
   left: 315.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Other Prorations", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 730.8,
   left: 49.68,
   width: 523.80,
   height: 11.64
}
,
{
   page: 11,
   name: "Amount Possession Per Day", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 106.08,
   left: 115.68,
   width: 79.92,
   height: 11.88
}
,
{
   page: 11,
   name: "Buyer represents that Buyer will not occupy the Home as Buyers principal residence", 
   isText: false,
   type: "checkbox",
   top: 164.76,
   left: 41.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 12,
   name: "Checkbox Specific Performance", 
   isText: false,
   type: "checkbox",
   top: 187.08,
   left: 95.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 13,
   name: "Percent Seller Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 580.64,
   left: 81.12,
   width: 34.92,
   height: 12.655
}
,
{
   page: 13,
   name: "Amount Seller Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 580.64,
   left: 229.92,
   width: 95.16,
   height: 12.655
}
,
{
   page: 13,
   name: "Percent Buyer Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 621.68,
   left: 81.12,
   width: 34.92,
   height: 12.655
}
,
{
   page: 13,
   name: "Amount Buyer Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 621.68,
   left: 229.92,
   width: 95.16,
   height: 12.655
}
,
{
   page: 13,
   name: "Percent Sellers Brokerage Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 650.0,
   left: 81.12,
   width: 34.92,
   height: 12.655
}
,
{
   page: 13,
   name: "Amount Sellers Brokerage Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 650.0,
   left: 229.92,
   width: 95.16,
   height: 12.655
}
,
{
   page: 13,
   name: "Electronic Notice", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 349.302,
   left: 61.8921,
   width: 502.1339,
   height: 13.403
}
,
{
   page: 14,
   name: "Additional Provisions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 61.776,
   left: 34.0205,
   width: 543.3845,
   height: 411.220
}
,
{
   page: 14,
   name: "Documents Part of Contract", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 530.112,
   left: 41.3628,
   width: 535.0412,
   height: 96.032
}
,
{
   page: 14,
   name: "Documents Not Part of Contract", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 639.017,
   left: 44.4798,
   width: 532.9782,
   height: 117.8353
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem Post-Closing Occupancy Agreement", 
   isText: false,
   type: "checkbox",
   top: 505.311,
   left: 97.5277,
   width: 10.0803,
   height: 10.080
}
,
{
   page: 15,
   name: "Buyer 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 90.71,
   left: 134.795,
   width: 435.000,
   height: 14.16
}
,
{
   page: 15,
   name: "Buyer 1 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 128.75,
   left: 134.795,
   width: 435.000,
   height: 14.04
}
,
{
   page: 15,
   name: "Buyer 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 143.51,
   left: 134.795,
   width: 170.040,
   height: 14.16
}
,
{
   page: 15,
   name: "Buyer 1 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 143.51,
   left: 447.275,
   width: 120.000,
   height: 14.16
}
,
{
   page: 15,
   name: "Buyer 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 159.51,
   left: 134.795,
   width: 435.000,
   height: 13.80
}
,
{
   page: 15,
   name: "Buyer 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 181.95,
   left: 134.795,
   width: 435.000,
   height: 14.16
}
,
{
   page: 15,
   name: "Buyer 2 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 219.197,
   left: 133.645,
   width: 435.000,
   height: 14.160
}
,
{
   page: 15,
   name: "Buyer 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 232.99,
   left: 134.795,
   width: 169.385,
   height: 14.16
}
,
{
   page: 15,
   name: "Buyer 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 232.99,
   left: 455.275,
   width: 120.000,
   height: 14.16
}
,
{
   page: 15,
   name: "Buyer 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 249.99,
   left: 134.795,
   width: 435.000,
   height: 13.80
}
,
{
   page: 15,
   name: "Buyer 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 272.641,
   left: 133.209,
   width: 434.999,
   height: 13.338
}
,
{
   page: 15,
   name: "Buyer 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 322.437,
   left: 133.526,
   width: 439.964,
   height: 12.837
}
,
{
   page: 15,
   name: "Seller 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 393.829,
   left: 134.988,
   width: 435.000,
   height: 13.338
}
,
{
   page: 15,
   name: "Seller 1 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 433.652,
   left: 135.998,
   width: 429.960,
   height: 13.338
}
,
{
   page: 15,
   name: "Seller 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 449.532,
   left: 135.343,
   width: 170.040,
   height: 13.338
}
,
{
   page: 15,
   name: "Seller 1 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 449.532,
   left: 448.478,
   width: 120.000,
   height: 13.338
}
,
{
   page: 15,
   name: "Seller 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 463.869,
   left: 134.166,
   width: 435.000,
   height: 13.338
}
,
{
   page: 15,
   name: "Seller 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 491.829,
   left: 134.166,
   width: 435.000,
   height: 13.338
}
,
{
   page: 15,
   name: "Seller 2 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 529.869,
   left: 134.166,
   width: 429.960,
   height: 13.338
}
,
{
   page: 15,
   name: "Seller 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 544.629,
   left: 134.166,
   width: 170.040,
   height: 13.338
}
,
{
   page: 15,
   name: "Seller 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 544.629,
   left: 446.646,
   width: 120.000,
   height: 13.338
}
,
{
   page: 15,
   name: "Seller 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 559.629,
   left: 134.166,
   width: 435.000,
   height: 13.338
}
,
{
   page: 15,
   name: "Seller 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 587.589,
   left: 134.166,
   width: 435.000,
   height: 13.338
}
,
{
   page: 15,
   name: "Seller 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 641.069,
   left: 134.166,
   width: 435.000,
   height: 13.338
}
,
{
   page: 16,
   name: "Radiobutton BuyerBrokerAcknowledgeReceiptEarnestMoney Does", 
   isText: false,
   type: "checkbox",
   top: 102.301,
   left: 96.1418,
   width: 10.0802,
   height: 10.080
}
,
{
   page: 16,
   name: "Radiobutton BuyerBrokerAcknowledgeReceiptEarnestMoney Does Not", 
   isText: false,
   type: "checkbox",
   top: 102.301,
   left: 145.822,
   width: 10.080,
   height: 10.554
}
,
{
   page: 16,
   name: "Radiobutton BuyerBrokerRelationship Buyers Agent", 
   isText: false,
   type: "checkbox",
   top: 185.566,
   left: 61.9855,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 16,
   name: "Radiobutton BuyerBrokerRelationship Transaction Broker", 
   isText: false,
   type: "checkbox",
   top: 200.766,
   left: 62.6619,
   width: 10.0801,
   height: 10.080
}
,
{
   page: 16,
   name: "Radiobutton BuyerBrokerRelationship Customer", 
   isText: false,
   type: "checkbox",
   top: 216.265,
   left: 62.7491,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 16,
   name: "Buyer Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 307.092,
   left: 181.461,
   width: 375.000,
   height: 12.480
}
,
{
   page: 16,
   name: "Buyer Brokerage Firm License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 321.4,
   left: 181.507,
   width: 375.000,
   height: 12.48
}
,
{
   page: 16,
   name: "Buyer Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 336.6,
   left: 181.507,
   width: 375.000,
   height: 12.48
}
,
{
   page: 16,
   name: "Buyer Broker License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 350.8,
   left: 182.507,
   width: 375.000,
   height: 12.48
}
,
{
   page: 16,
   name: "Signature Buyer Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 370.676,
   left: 187.624,
   width: 178.546,
   height: 13.000
}
,
{
   page: 16,
   name: "Date Signature Buyer Broker", 
   fontSize: 9,
   type: "date",
   top: 371.469,
   left: 383.031,
   width: 78.164,
   height: 12.480
}
,
{
   page: 16,
   name: "Buyer CoAgent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 488.485,
   left: 190.607,
   width: 355.396,
   height: 13.784
}
,
{
   page: 16,
   name: "Signature Buyer CoAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 509.767,
   left: 190.185,
   width: 184.437,
   height: 13.000
}
,
{
   page: 16,
   name: "Date Signature Buyer CoAgent", 
   fontSize: 9,
   type: "date",
   top: 510.87,
   left: 388.843,
   width: 81.949,
   height: 11.825
}
,
{
   page: 16,
   name: "Buyer Brokerage Address Street", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 400.538,
   left: 182.136,
   width: 375.000,
   height: 12.480
}
,
{
   page: 16,
   name: "Buyer Brokerage Address City State Zip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 415.738,
   left: 182.136,
   width: 375.000,
   height: 12.480
}
,
{
   page: 16,
   name: "Buyer Broker Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 429.938,
   left: 182.136,
   width: 375.000,
   height: 12.480
}
,
{
   page: 16,
   name: "Buyer Broker Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 459.926,
   left: 182.136,
   width: 375.000,
   height: 12.480
}
,
{
   page: 16,
   name: "Buyer Broker Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 443.101,
   left: 181.346,
   width: 375.819,
   height: 14.800
}
,
{
   page: 16,
   name: "Radiobutton SellerBrokerAcknowledgeReceiptEarnestMoney Does", 
   isText: false,
   type: "checkbox",
   top: 607.208,
   left: 99.083,
   width: 10.080,
   height: 10.080
}
,
{
   page: 16,
   name: "Radiobutton SellerBrokerAcknowledgeReceiptEarnestMoney Does Not", 
   isText: false,
   type: "checkbox",
   top: 607.208,
   left: 145.723,
   width: 10.080,
   height: 10.080
}
,
{
   page: 16,
   name: "Radiobutton SellerBrokerRelationship Sellers Agent", 
   isText: false,
   type: "checkbox",
   top: 690.768,
   left: 66.203,
   width: 10.080,
   height: 10.080
}
,
{
   page: 16,
   name: "Radiobutton SellerBrokerRelationship Transaction Broker", 
   isText: false,
   type: "checkbox",
   top: 705.848,
   left: 66.203,
   width: 10.080,
   height: 10.080
}
,
{
   page: 16,
   name: "Radiobutton SellerBrokerRelationship Customer", 
   isText: false,
   type: "checkbox",
   top: 721.168,
   left: 66.203,
   width: 10.080,
   height: 10.080
}
,
{
   page: 17,
   name: "Checkbox SellerBrokerageFirmPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 52.07,
   left: 66.203,
   width: 10.080,
   height: 10.08
}
,
{
   page: 17,
   name: "Checkbox SellerBrokerageFirmPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 66.841,
   left: 66.5303,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 17,
   name: "Checkbox SellerBrokerageFirmPaidBy Other", 
   isText: false,
   type: "checkbox",
   top: 83.161,
   left: 66.5303,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 17,
   name: "SellerBrokerageFirmPaidBy Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 80.205,
   left: 110.935,
   width: 451.908,
   height: 13.102
}
,
{
   page: 17,
   name: "Seller Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 142.491,
   left: 189.786,
   width: 361.968,
   height: 13.631
}
,
{
   page: 17,
   name: "Seller Brokerage Firm License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 157.64,
   left: 189.786,
   width: 361.968,
   height: 13.631
}
,
{
   page: 17,
   name: "Seller Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 172.52,
   left: 189.786,
   width: 361.968,
   height: 13.631
}
,
{
   page: 17,
   name: "Seller Broker License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 187.277,
   left: 189.786,
   width: 361.968,
   height: 13.631
}
,
{
   page: 17,
   name: "Signature Broker Seller", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 217.168,
   left: 187.677,
   width: 188.619,
   height: 13.887
}
,
{
   page: 17,
   name: "Date Signature Broker Seller", 
   fontSize: 9,
   type: "date",
   top: 217.168,
   left: 390.563,
   width: 90.764,
   height: 13.887
}
,
{
   page: 17,
   name: "Seller Brokerage Address Street", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 255.549,
   left: 185.956,
   width: 382.680,
   height: 13.887
}
,
{
   page: 17,
   name: "Seller Brokerage Address City State Zip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 269.944,
   left: 187.321,
   width: 383.329,
   height: 13.784
}
,
{
   page: 17,
   name: "Seller Broker Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 285.36,
   left: 188.051,
   width: 382.680,
   height: 13.887
}
,
{
   page: 17,
   name: "Seller Broker Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 300.643,
   left: 188.051,
   width: 382.680,
   height: 13.887
}
,
{
   page: 17,
   name: "Seller Broker Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 315.403,
   left: 187.986,
   width: 383.400,
   height: 13.887
}
,
{
   page: 17,
   name: "Seller CoAgent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 343.886,
   left: 188.964,
   width: 357.860,
   height: 15.428
}
,
{
   page: 17,
   name: "Signature Seller CoAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 373.33,
   left: 189.25,
   width: 184.854,
   height: 12.976
}
,
{
   page: 17,
   name: "Date Signature Seller CoAgent", 
   fontSize: 9,
   type: "date",
   top: 372.33,
   left: 396.327,
   width: 80.188,
   height: 14.453
}
] }
